import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
// import FormattedMessage from 'I18n/components/FormattedMessage';

import BranchMixin, { BranchMixinDefaultValues, branchFromJSON } from 'automation-ui-action-features/records/BranchMixin';

/**
 * A WhileLoopBranch represents the "condition met"
 * branch.
 */
class WhileLoopBranch extends BranchMixin(createImmutableObjectClass(BranchMixinDefaultValues, {
  fromJSON: branchFromJSON,
  toJSON: branch => branch
})) {
  getBranchName() {
    return 'TODO: condition met';
    // return (
    // <FormattedMessage message="automation-ui-action-features.action-features.while-loop.branch-names.condition-met" />
    // );
  }
  setBranchName() {
    return this;
  }

  // TODO
  setValue(filters) {
    return filters;
  }
}
export default WhileLoopBranch;